import React from 'react';
import { Link } from 'react-router-dom';
import { CarIcon, CreditCardIcon, BadgeDollarSignIcon, ClipboardListIcon, MessageCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
import { CATALOGO_URL } from '../../data/brand';
interface Action {
  icon: typeof CarIcon;
  title: string;
  text: string;
  cta: string;
  to?: string;
  href?: string;
  featured?: boolean;
}
const actions: Action[] = [{
  icon: CarIcon,
  title: 'Catálogo',
  text: 'Explorá nuestros usados seleccionados y 0KM disponibles.',
  cta: 'Ver vehículos',
  href: CATALOGO_URL,
  featured: true
}, {
  icon: CreditCardIcon,
  title: 'Financiación 0KM',
  text: 'Consultá planes, cuotas y opciones para acceder a tu próximo 0KM.',
  cta: 'Consultar financiación',
  to: '/financiacion'
}, {
  icon: BadgeDollarSignIcon,
  title: 'Quiero vender mi auto',
  text: 'Nos encargamos de gestionar la venta de tu vehículo de forma profesional.',
  cta: 'Vender mi auto',
  to: '/vender-mi-auto'
}, {
  icon: ClipboardListIcon,
  title: 'Dejar mi consulta',
  text: 'Contanos qué vehículo buscás o qué operación querés realizar.',
  cta: 'Completar formulario',
  to: '/contacto'
}, {
  icon: MessageCircleIcon,
  title: 'Comunicate con un vendedor',
  text: 'Recibí atención personalizada por WhatsApp.',
  cta: 'Hablar ahora',
  href: whatsappLink(GENERAL_WA_MESSAGE)
}];
function ActionBody({
  action
}: {
  action: Action;
}) {
  const Icon = action.icon;
  return <>
      <span className={`inline-grid place-items-center rounded-xl ${action.featured ? 'h-12 w-12 bg-neon text-white' : 'h-11 w-11 bg-neon/12 text-neon'}`} data-id="element-311" data-mp="xuv6evvjx0pm">
        <Icon className={action.featured ? 'h-6 w-6' : 'h-5 w-5'} aria-hidden="true" data-id="element-312" data-mp="16rlyyyaw9xfg" />
      </span>
      <h3 className={`mt-5 font-bold text-white ${action.featured ? 'text-2xl md:text-[28px]' : 'text-lg'}`} data-id="element-313" data-mp="1bq6y0ueeub2b">
        {action.title}
      </h3>
      <p className={`mt-2 leading-relaxed text-mist ${action.featured ? 'max-w-md text-[15px]' : 'text-sm'}`} data-id="element-314" data-mp="32yeir9rpqu2m">
        {action.text}
      </p>
      <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-sm font-semibold text-neon-soft" data-id="element-315" data-mp="3ctzhmz1hje85">
        {action.cta}
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-316" data-mp="3qo8ufo0aqcla" />
      </span>
    </>;
}
export function QuickActions() {
  return <Section id="accesos" className="bg-surface" data-id="element-317" data-mp="4fhf1cubcqvx">
      <SectionHeading title="¿Qué querés hacer hoy?" lead="Elegí el camino más directo: comprar, vender, financiar o hablar con un asesor." data-id="element-318" data-mp="4e69b7hb5926" />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-319" data-mp="267do8ft0donj">
        {actions.map(a => {
        const className = `group flex flex-col rounded-2xl border border-line bg-surface2/50 p-6 transition-[border-color,transform,background-color] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-neon/50 hover:bg-surface2 ${a.featured ? 'md:col-span-2 md:p-8' : ''}`;
        return a.href ? <a key={a.title} href={a.href} target="_blank" rel="noopener noreferrer" className={className} data-id="element-320" data-mp="6z40a1lgdoxe">
              <ActionBody action={a} data-id="element-321" data-mp="3u2s8pulyx0qh" />
            </a> : <Link key={a.title} to={a.to as string} className={className} data-id="element-322" data-mp="2ytt4llxcsgy">
              <ActionBody action={a} data-id="element-323" data-mp="3k65s5i0ocvu9" />
            </Link>;
      })}
      </div>
    </Section>;
}